import { Link, useLocation } from "react-router-dom";
import { LogOut } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { BrandMark } from "@/components/BrandMark";
import { ACCENTS } from "@/components/portal/portalConfig";
import { cn } from "@/lib/utils";

export const Sidebar = ({ config, onNavigate }) => {
  const { pathname } = useLocation();
  const { user, logout } = useAuth();
  const a = ACCENTS[config.accent];

  return (
    <div className="flex h-full flex-col text-slate-300" style={{ backgroundColor: "#0F172A" }}>
      {/* Brand */}
      <Link to={config.nav[0].to} onClick={onNavigate} className="flex h-16 items-center gap-2.5 px-4">
        <BrandMark className="h-9" />
        <div className="leading-tight">
          <div className="font-heading text-base font-bold text-white">Z2Infinity</div>
          <div className="text-[10px] font-medium uppercase tracking-[0.15em] text-slate-500">{config.label}</div>
        </div>
      </Link>

      {/* Nav */}
      <nav className="flex-1 space-y-1 overflow-y-auto px-3 py-3">
        {config.nav.map((item, i) => {
          if (item.section) {
            return (
              <div key={`s-${i}`} className="px-3 pb-1 pt-4">
                <div className="mb-1 border-t border-slate-700/60" />
                <span className="text-[10px] font-semibold uppercase tracking-[0.15em] text-slate-500">{item.section}</span>
              </div>
            );
          }
          const active = pathname === item.to;
          return (
            <Link
              key={item.to}
              to={item.to}
              onClick={onNavigate}
              aria-current={active ? "page" : undefined}
              data-testid={`sidenav-${item.label.toLowerCase().replace(/\s/g, "-")}`}
              className={cn(
                "flex h-11 items-center gap-3 rounded-lg px-3 text-[13px] font-medium transition-colors",
                active ? a.active : "text-slate-400 hover:bg-slate-800 hover:text-white"
              )}
            >
              <item.icon className="h-[18px] w-[18px] flex-shrink-0" />
              {item.label}
            </Link>
          );
        })}
      </nav>

      {/* User card */}
      <div className="border-t border-slate-800 p-3">
        <div className="flex items-center gap-3 rounded-lg px-2 py-2">
          <span className="flex h-8 w-8 flex-shrink-0 items-center justify-center rounded-full bg-slate-700 text-xs font-bold uppercase text-white">
            {user?.picture ? <img src={user.picture} alt="" className="h-8 w-8 rounded-full object-cover" /> : (user?.name || user?.email || "?")[0]}
          </span>
          <div className="min-w-0 flex-1">
            <div className="truncate text-[13px] font-medium text-white">{user?.name}</div>
            <div className="truncate text-[11px] text-slate-500">{user?.examPreference || "Student"}</div>
          </div>
          <button onClick={logout} data-testid="sidebar-logout" aria-label="Sign out" className="flex h-8 w-8 items-center justify-center rounded-lg text-slate-400 hover:bg-slate-800 hover:text-white">
            <LogOut className="h-4 w-4" />
          </button>
        </div>
      </div>
    </div>
  );
};
